// PartnerConfigurationEditPage
import InputText from "../../../components/common/InputText/InputText";
import ConfigurationEditPage from "../../../components/management/PartnerGenericConfigurationPages/ConfigurationEditPage";
import useConfigurationForm from "../../../components/management/PartnerGenericConfigurationPages/hooks/useConfigurationForm";
import { partnerConfigValidators } from "../../../components/management/PartnerGenericConfigurationPages/validators/partnerConfigValidators";
import { paths } from "../../../routes/paths";
import "./PartnerConfigurationEditPage.scss";

const PartnerConfigurationEditPage = () => {
  const configKey = "partner_configuration";

  const formProps = useConfigurationForm(configKey, partnerConfigValidators);
  const { formData, fieldErrors, handleInputChange } = formProps;

  const breadcrumbPath = [
    {
      href: "/",
      label: "Home",
    },
    {
      href: `../../${paths.system_setting}`,
      label: "System setting",
    },
    {
      href: `../../${paths.system_setting}/${paths.partner_configuration}/edit`,
      label: "Partner Configuration Edit",
    },
  ];

  return (
    <ConfigurationEditPage
      configKey={configKey}
      configType="partner configuration"
      headerText="Partner Configuration Edit"
      description="Setup and configuration details for partners."
      breadcrumbPath={breadcrumbPath}
      formProps={formProps}
    >
      <InputText
        label="Package Partner"
        placeholder="Type partner name"
        onChange={handleInputChange}
        className="partner-configuration-input"
        name="package_partner"
        value={formData.package_partner || ""}
        errorMessage={fieldErrors.package_partner}
        required
      />

      <InputText
        label="Receipt Partner"
        placeholder="Type partner name"
        onChange={handleInputChange}
        className="partner-configuration-input"
        name="receipt_partner"
        value={formData.receipt_partner || ""}
        errorMessage={fieldErrors.receipt_partner}
        required
      />

      <InputText
        label="Generic Notification Partner"
        placeholder="Type partner name"
        className="partner-configuration-input"
        onChange={handleInputChange}
        name="generic_notification_partner"
        value={formData.generic_notification_partner || ""}
        errorMessage={fieldErrors.generic_notification_partner}
        required
      />
    </ConfigurationEditPage>
  );
};

export default PartnerConfigurationEditPage;
